module.exports = __webpack_public_path__ + "img/icon-visa.18781bc5.svg";